import { DOCUMENT, inject, Injectable, signal } from '@angular/core';

/** Klíč v localStorage s volbou tmavého režimu ('true' / 'false'). */
const DARK_MODE_STORAGE_KEY = 'darkMode';
/** Třída na <html>, kterou Optimus UI bere jako tmavý režim (`darkModeSelector: '.dark'`). */
const DARK_MODE_CLASS = 'dark';

/**
 * Jediný zdroj stavu tmavého režimu: signál `isDark`, třída `dark` na `<html>` a volba v localStorage.
 * Výchozí stav: uložená volba, jinak systémové `prefers-color-scheme`.
 */
@Injectable({ providedIn: 'root' })
export class DarkModeService {
  private readonly document = inject(DOCUMENT);
  private readonly dark = signal(this.readInitial());

  readonly isDark = this.dark.asReadonly();

  constructor() {
    this.applyClass(this.dark());
  }

  setDark(isDark: boolean): void {
    this.dark.set(isDark);
    this.applyClass(isDark);
    try {
      this.document.defaultView?.localStorage.setItem(DARK_MODE_STORAGE_KEY, String(isDark));
    } catch {
      // localStorage nemusí být dostupný (soukromé okno, zakázané úložiště) – volba pak platí jen do obnovení
    }
  }

  private readInitial(): boolean {
    const window = this.document.defaultView;
    try {
      const stored = window?.localStorage.getItem(DARK_MODE_STORAGE_KEY);
      if (stored !== null && stored !== undefined) {
        return stored === 'true';
      }
    } catch {
      // bez localStorage rozhoduje systémové nastavení
    }
    return window?.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
  }

  private applyClass(isDark: boolean): void {
    this.document.documentElement.classList.toggle(DARK_MODE_CLASS, isDark);
  }
}
